import { MeasurementContext } from '@src/common/measurements/MeasurementContext';
import { useContext } from 'react';

export const useMeasurement = () => {
  const { isMetric, setIsMetric } = useContext(MeasurementContext);

  return { isMetric, setIsMetric };
};
